import { render, staticRenderFns } from "./RightBottom.vue?vue&type=template&id=d2634c68&scoped=true"
import script from "./RightBottom.vue?vue&type=script&lang=js"
export * from "./RightBottom.vue?vue&type=script&lang=js"
import style0 from "./RightBottom.vue?vue&type=style&index=0&id=d2634c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2634c68",
  null
  
)

export default component.exports